import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import _isEqual from 'lodash/isEqual';

// import { useDevice } from '@bonnet/next/device';

// import { useFeatures } from '@atc/features';
// import { ClientOnly } from '@atc/react-client-only';

import { Chip, Link } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
// import { OwnerChat } from 'reaxl-molecules';
import { DigitalRetailOverlayCTA } from 'reaxl-wallet';

import offsetCalc from '@/utilities/offSetScrollCalculation';
import scrollToElement from '@/utilities/scrollToElement';

import { snapshotPaymentDetailsClick } from '@/analytics/vdpAnalyticsHandlers';

import dealsDuck from '@/ducks/dealsDuck.js';
import paymentsDuck from '@/ducks/paymentsDuck';
import userDuck from '@/ducks/userDuck';
import vdpActiveEmailListingDuck from '@/ducks/vdp/vdpActiveEmailListingDuck.js';
import vdpActiveInteractionDuck from '@/ducks/vdp/vdpActiveInteractionDuck.js';
import vdpModelInfoDuck from '@/ducks/vdp/vdpModelInfoDuck.js';
import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

import ShoppingAssistantContainer from '@/containers/ShoppingAssistantContainer';

function VdpShoppingAssistantContainer() {

    const [showAssistant, setShowAssistant] = useState(false);

    const dispatch = useDispatch();

    // const device = useDevice();
    // const isXs = device?.is?.xs;

    // const {
    //     chat: [isChatEnabled, { providers: chatProviders, enable_mobile_chat: isMobileChatEnabled }],
    // } = useFeatures(['chat']);

    const paymentsInfo = useSelector(paymentsDuck.selectors.getPaymentsInfo);

    const modelInfo = useSelector(vdpModelInfoDuck.selectors.getModelInfo);
    const listing = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory);
    const {
        styleId,
        vhrTiles = [],
        // owner = {},
    } = listing || {};
    // const { chat = {} } = owner;

    // const showChatCta = !!(isChatEnabled && (!isXs || isMobileChatEnabled) && !!chat?.provider && chatProviders?.includes(chat?.provider));

    useEffect(() => {
        dispatch(vdpModelInfoDuck.creators.loadModelInfo({ styleId }));
        return () => { dispatch(vdpModelInfoDuck.creators.clear()); };
    }, [styleId, dispatch]);

    const checkAvailabilityTitle = 'Check availability';
    const scheduleTestDriveTitle = 'Schedule test drive';
    // const chatWithSellerTitle = 'Chat with seller';
    const vehicleHistoryReportTitle = 'See history report';
    const estimatePaymentTitle = 'Estimate payment';
    const vehicleSpecificationsTitle = 'See features and specs';

    const handleAssistantClose = () => setShowAssistant(false);

    const handleCheckAvailabilityClick = (event) => {
        handleAssistantClose();
        setTimeout(() => {
            dispatch(vdpActiveInteractionDuck.creators.setKeys({
                showEmailModal: true,
            }));
        }, 300);
    };

    const checkAvailabilityCta = (
        <Chip
            uiContext="inquiry"
            onClick={handleCheckAvailabilityClick}
            data-cmp="suggested-filter-button"
            label={checkAvailabilityTitle}
        />
    );

    const handleTestDriveCtaClick = (event) => {
        handleAssistantClose();

        // sendClick(testDriveScheduleClick, event, { listingId: listing.id, placement: 'nba' });

        if (!listing?.accelerate) {
            setTimeout(() => {
                dispatch(vdpActiveEmailListingDuck.creators.setActiveResults([listing.id]));
                dispatch(vdpActiveInteractionDuck.creators.setKeys({
                    emailCTAContext: 'testDrive',
                    showEmailModal: true,
                }));
            }, 300);
        }
    };

    const scheduleTestDriveCta = listing.accelerate ? (
        <DigitalRetailOverlayCTA
            data-cmp="suggested-filter-button"
            dealsDuck={dealsDuck}
            listing={listing}
            onClick={handleTestDriveCtaClick}
            paymentsDuck={paymentsDuck}
            paymentsInfo={paymentsInfo}
            uiContext="shoppingAssistant"
            userDuck={userDuck}
        />
    ) : (
        <Chip
            uiContext="inquiry"
            onClick={handleTestDriveCtaClick}
            data-cmp="suggested-filter-button"
            label={scheduleTestDriveTitle}
        />
    );

    // const analyticsData = {
    //     inventoryId: listing.id,
    //     ownerId: owner.id,
    //     placement: 'snapshot',
    // };
    // const handleSellerChatClick = () => {
    //     // TODO: Open chat modal/window
    //     handleAssistantClose();
    // };

    // const chatWithSellerCta = showChatCta && (
    //     <ClientOnly>
    //         <Chip
    //             uiContext="inquiry"
    //             onClick={handleSellerChatClick}
    //             data-cmp="suggested-filter-button"
    //             label={(
    //                 <OwnerChat
    //                     {...chat}
    //                     analyticsData={analyticsData}
    //                     listing={listing}
    //                     merchantId={owner.id}
    //                     uiContext="snapshot"
    //                     label={chatWithSellerTitle}
    //                 />
    //             )}
    //         />
    //     </ClientOnly>
    // );

    const vhrLink = vhrTiles?.[0]?.link?.href;
    const vehicleHistoryReportCta = !!vhrLink && (
        <Link
            href={vhrLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleAssistantClose}
        >
            <Chip
                uiContext="inquiry"
                data-cmp="suggested-filter-button"
                label={vehicleHistoryReportTitle}
            />
        </Link>
    );

    const scrollToNativeDealSection = () => {
        const offset = offsetCalc(25, 'sticky-header-vdp');
        const isNDSRendered = document.getElementById('nds');
        const destination = isNDSRendered ? 'nds' : 'nativeDealContainer';
        scrollToElement(destination, offset);
    };

    const handleWalletPricingDetailsClick = (event) => {
        handleAssistantClose();
        setTimeout(() => {
            scrollToNativeDealSection();
        }, 300);
        sendClick(snapshotPaymentDetailsClick, event, {});
    };

    const estimatePaymentCta = (
        <Chip
            uiContext="inquiry"
            onClick={handleWalletPricingDetailsClick}
            data-cmp="suggested-filter-button"
            label={estimatePaymentTitle}
        />
    );

    const handleFeaturesSpecsClick = (event) => {
        handleAssistantClose();
        setTimeout(() => {
            dispatch(vdpActiveInteractionDuck.creators.setKeys({
                showModelInfoModal: true,
            }));
        }, 300);
    };

    const vehicleSpecificationsCta = (modelInfo && Object.keys(modelInfo).length) && (
        <Chip
            uiContext="inquiry"
            onClick={handleFeaturesSpecsClick}
            data-cmp="suggested-filter-button"
            label={vehicleSpecificationsTitle}
        />
    );

    const suggestedActions = (
        <>
            {checkAvailabilityCta}
            {scheduleTestDriveCta}
            {/* {chatWithSellerCta} */}
            {vehicleHistoryReportCta}
            {estimatePaymentCta}
            {vehicleSpecificationsCta}
        </>
    );

    return (
        <ShoppingAssistantContainer
            handleAssistantClose={handleAssistantClose}
            setShowAssistant={setShowAssistant}
            showAssistant={showAssistant}
            suggestedActions={suggestedActions}
            suppressKeyword
        />
    );
}

export default React.memo(VdpShoppingAssistantContainer, _isEqual);
